// Landing-page copy in English + Greek. Keep keys in sync across both objects.
// Terminology mirrors the app's own Greek strings (προσφορές / εκπτώσεις /
// εξαργύρωση / κατάστημα) so the site and app read consistently.
export const translations = {
  en: {
    // Nav
    nav_features: "Features",
    nav_how: "How It Works",
    nav_faq: "FAQ",
    nav_cta: "Go to App",

    // Hero
    hero_title_1: "Discover Local Offers",
    hero_title_2: "In Real-Time",
    hero_sub:
      "Connect with nearby stores offering time-limited discounts. Save money while supporting local businesses.",

    // Features
    features_title: "Why Choose tiphop?",
    features_sub: "Everything you need to save money and discover amazing local offers",
    feat_location_t: "Location-Based Discovery",
    feat_location_d:
      "Find offers from stores within your chosen radius — from 500m up to 50km. Never miss an offer right next door.",
    feat_realtime_t: "Real-Time & Scheduled Offers",
    feat_realtime_d:
      "Grab time-limited offers the moment they drop, and see what's starting later today. Stores push last-minute discounts to fill unused capacity.",
    feat_notifications_t: "Smart Notifications",
    feat_notifications_d:
      "Personalized alerts for your favorite categories and distance — with quiet hours so you're never pinged in the middle of the night.",
    feat_follow_t: "Follow Your Favorite Stores",
    feat_follow_d:
      "Follow the stores you love and get notified the instant they post a new offer.",
    feat_dinein_t: "Dine-In Reservations",
    feat_dinein_d:
      "Reserve a table offer for your whole party at a fixed price per person — perfect for food, drinks, and sweets.",
    feat_bookmark_t: "Save & Get Reminded",
    feat_bookmark_d:
      "Bookmark a scheduled offer and we'll notify you the moment it goes live — so you're first in line.",
    feat_share_t: "Share Offers",
    feat_share_d: "Found a great offer? Share it with friends and family in a single tap.",
    feat_verified_t: "Real Customer Ratings",
    feat_verified_d:
      "Every store shows a star rating from customers who actually redeemed an offer there. Book and buy with confidence.",
    feat_savings_t: "Track Your Savings",
    feat_savings_d:
      "Save up to 70% on local products and services, and watch your total savings add up over time.",
    feat_qr_t: "Easy QR Redemption",
    feat_qr_d: "One-tap redemption with a QR code at checkout. Simple, fast, and secure.",
    feat_localization_t: "Your Language, Your Theme",
    feat_localization_d:
      "Full English & Greek support, light or dark mode, and installable on any phone — no app store required.",
    feat_free_t: "Free to Start, Pay on Results",
    feat_free_d:
      "Always free for shoppers. For stores, no subscriptions and no upfront fees — just a small commission on offers that are actually redeemed. You only pay when it works.",
    feat_reverse_t: "Ask for an Offer",
    feat_reverse_d:
      "No offer nearby? Anonymously nudge a local store to post one. Stores see the demand and can respond — you help bring the offers you want.",

    // How it works
    how_title: "How It Works",
    how_sub: "Start saving in three simple steps",
    step1_t: "Open & Sign Up",
    step1_d: "Open the app and create your free account in seconds.",
    step2_t: "Browse Local Offers",
    step2_d: "Explore offers from nearby stores. Filter by category, distance, and discount amount.",
    step3_t: "Redeem & Save",
    step3_d: "Show your QR code at checkout and enjoy instant savings. It's that simple!",

    // Screenshots
    shots_title: "See It In Action",
    shots_sub: "A glimpse of our beautiful and intuitive interface",
    shot1: "Browse Local Offers",
    shot2: "View Offer Details",
    shot3: "Redeem in Seconds",

    // FAQ
    faq_title: "Frequently Asked Questions",
    faq_sub: "Everything you need to know",
    faq1_q: "How does tiphop work?",
    faq1_a:
      "tiphop connects you with nearby stores offering time-limited discounts. Simply open the app, enable location services, and browse offers in your area. When you find an offer you like, tap to redeem and show the QR code at checkout.",
    faq2_q: "Is the app really free for consumers?",
    faq2_a:
      "Yes! tiphop is 100% free for consumers — no subscription fees, hidden charges, or transaction fees. For stores, there are no subscriptions or upfront fees — just a small commission on offers that are actually redeemed.",
    faq3_q: "How do I redeem an offer?",
    faq3_a:
      "Redemption is simple! Once you find an offer you want, tap the “Redeem” button in the app. A unique QR code will be generated. Show this code to the store at checkout, and they'll scan it to apply your discount instantly.",
    faq4_q: "Can I save offers for later?",
    faq4_a:
      "Yes! On an offer that starts later, tap “Notify me when live” and we'll let you know the moment it goes live. If it's about to end and you still haven't claimed it, we'll send you a reminder before it closes.",
    faq5_q: "I run a store. How do I get started?",
    faq5_a:
      "Getting started is easy, with nothing to pay upfront. Sign up for a store account through the app or our website and you can start posting offers immediately. There are no plans, subscription fees, or posting charges — just a small commission on offers that are actually redeemed. Our team will guide you through the setup process.",
    faq6_q: "What types of businesses can use tiphop?",
    faq6_a:
      "Any local business with physical locations can use tiphop! This includes restaurants, cafes, retail stores, salons, fitness centers, entertainment venues, and service providers. If you have unused capacity or inventory you'd like to sell at a discount, tiphop is perfect for you.",

    // CTA + contact
    cta_title: "Ready to Start Saving?",
    cta_sub:
      "Join thousands of users discovering amazing local offers every day. Open the app and get your first offer!",
    contact_title: "Get In Touch",
    contact_sub: "Have questions? We'd love to hear from you.",
    form_name: "Your Name",
    form_email: "Your Email",
    form_message: "Your Message",
    form_send: "Send Message",
    form_sending: "Sending…",
    form_thanks: "Thank you! We'll get back to you soon.",
    form_error: "Couldn't send. Please email us at tiphop.app@gmail.com.",

    // Footer
    footer_tagline: "Connecting consumers with local stores through time-limited discounts.",
    footer_product: "Product",
    footer_company: "Company",
    footer_legal: "Legal",
    footer_about: "About Us",
    footer_careers: "Careers",
    footer_blog: "Blog",
    footer_privacy: "Privacy Policy",
    footer_terms: "Terms of Service",
    footer_cookies: "Cookie Policy",
    footer_rights: "© {year} tiphop. All rights reserved.",
  },

  el: {
    // Nav
    nav_features: "Δυνατότητες",
    nav_how: "Πώς Λειτουργεί",
    nav_faq: "Συχνές Ερωτήσεις",
    nav_cta: "Στην Εφαρμογή",

    // Hero
    hero_title_1: "Ανακάλυψε Τοπικές Προσφορές",
    hero_title_2: "Σε Πραγματικό Χρόνο",
    hero_sub:
      "Σύνδεσου με κοντινά καταστήματα που προσφέρουν χρονικά περιορισμένες εκπτώσεις. Εξοικονόμησε χρήματα στηρίζοντας τις τοπικές επιχειρήσεις.",

    // Features
    features_title: "Γιατί να διαλέξεις το tiphop;",
    features_sub: "Όλα όσα χρειάζεσαι για να εξοικονομείς χρήματα και να ανακαλύπτεις σπουδαίες τοπικές προσφορές",
    feat_location_t: "Ανακάλυψη με βάση την τοποθεσία",
    feat_location_d:
      "Βρες προσφορές από καταστήματα μέσα στην ακτίνα που επιλέγεις — από 500μ έως 50χλμ. Μη χάνεις ποτέ μια προσφορά δίπλα σου.",
    feat_realtime_t: "Προσφορές σε πραγματικό χρόνο & προγραμματισμένες",
    feat_realtime_d:
      "Άρπαξε χρονικά περιορισμένες προσφορές τη στιγμή που εμφανίζονται και δες τι ξεκινά αργότερα σήμερα. Τα καταστήματα ανεβάζουν εκπτώσεις τελευταίας στιγμής για να καλύψουν αδιάθετη διαθεσιμότητα.",
    feat_notifications_t: "Έξυπνες ειδοποιήσεις",
    feat_notifications_d:
      "Εξατομικευμένες ειδοποιήσεις για τις αγαπημένες σου κατηγορίες και απόσταση — με ώρες ησυχίας, ώστε να μη σε ενοχλούμε μέσα στη νύχτα.",
    feat_follow_t: "Ακολούθησε τα αγαπημένα σου καταστήματα",
    feat_follow_d:
      "Ακολούθησε τα καταστήματα που αγαπάς και ειδοποιήσου τη στιγμή που ανεβάζουν νέα προσφορά.",
    feat_dinein_t: "Κρατήσεις για επιτόπου κατανάλωση",
    feat_dinein_d:
      "Κράτησε μια προσφορά τραπεζιού για όλη την παρέα σε σταθερή τιμή ανά άτομο — ιδανικό για φαγητό, ποτά και γλυκά.",
    feat_bookmark_t: "Αποθήκευσε & θυμήσου",
    feat_bookmark_d:
      "Αποθήκευσε μια προγραμματισμένη προσφορά και θα σε ειδοποιήσουμε μόλις ενεργοποιηθεί — για να είσαι πρώτος στη σειρά.",
    feat_share_t: "Μοιράσου προσφορές",
    feat_share_d: "Βρήκες μια εξαιρετική προσφορά; Μοιράσου την με φίλους και οικογένεια με ένα άγγιγμα.",
    feat_verified_t: "Πραγματικές αξιολογήσεις πελατών",
    feat_verified_d:
      "Κάθε κατάστημα έχει βαθμολογία από πελάτες που εξαργύρωσαν πραγματικά μια προσφορά εκεί. Κράτησε και αγόρασε με σιγουριά.",
    feat_savings_t: "Παρακολούθησε την εξοικονόμησή σου",
    feat_savings_d:
      "Εξοικονόμησε έως και 70% σε τοπικά προϊόντα και υπηρεσίες και δες τη συνολική σου εξοικονόμηση να μεγαλώνει με τον καιρό.",
    feat_qr_t: "Εύκολη εξαργύρωση με QR",
    feat_qr_d: "Εξαργύρωση με ένα άγγιγμα μέσω κωδικού QR στο ταμείο. Απλό, γρήγορο και ασφαλές.",
    feat_localization_t: "Η γλώσσα σου, το θέμα σου",
    feat_localization_d:
      "Πλήρης υποστήριξη Ελληνικών & Αγγλικών, φωτεινό ή σκούρο θέμα, και εγκατάσταση σε κάθε κινητό — χωρίς app store.",
    feat_free_t: "Δωρεάν Έναρξη, Πληρώνεις στα Αποτελέσματα",
    feat_free_d:
      "Πάντα δωρεάν για τους καταναλωτές. Για τα καταστήματα, χωρίς συνδρομές και χωρίς πάγιες χρεώσεις — μόνο μια μικρή προμήθεια στις προσφορές που όντως εξαργυρώνονται. Πληρώνεις μόνο όταν αποδίδει.",
    feat_reverse_t: "Ζήτησε μια Προσφορά",
    feat_reverse_d:
      "Καμία προσφορά κοντά σου; Ζήτησε ανώνυμα από ένα τοπικό κατάστημα να ανεβάσει μία. Τα καταστήματα βλέπουν τη ζήτηση και μπορούν να ανταποκριθούν — βοηθάς να έρθουν οι προσφορές που θέλεις.",

    // How it works
    how_title: "Πώς Λειτουργεί",
    how_sub: "Ξεκίνα να εξοικονομείς σε τρία απλά βήματα",
    step1_t: "Άνοιξε & εγγράψου",
    step1_d: "Άνοιξε την εφαρμογή και δημιούργησε τον δωρεάν λογαριασμό σου σε δευτερόλεπτα.",
    step2_t: "Περιηγήσου σε τοπικές προσφορές",
    step2_d: "Εξερεύνησε προσφορές από κοντινά καταστήματα. Φιλτράρισε ανά κατηγορία, απόσταση και ποσό έκπτωσης.",
    step3_t: "Εξαργύρωσε & εξοικονόμησε",
    step3_d: "Δείξε τον κωδικό QR στο ταμείο και απόλαυσε άμεση εξοικονόμηση. Τόσο απλά!",

    // Screenshots
    shots_title: "Δες το σε δράση",
    shots_sub: "Μια ματιά στο όμορφο και εύχρηστο περιβάλλον μας",
    shot1: "Περιήγηση σε τοπικές προσφορές",
    shot2: "Λεπτομέρειες προσφοράς",
    shot3: "Εξαργύρωση σε δευτερόλεπτα",

    // FAQ
    faq_title: "Συχνές Ερωτήσεις",
    faq_sub: "Όλα όσα χρειάζεται να ξέρεις",
    faq1_q: "Πώς λειτουργεί το tiphop;",
    faq1_a:
      "Το tiphop σε συνδέει με κοντινά καταστήματα που προσφέρουν χρονικά περιορισμένες εκπτώσεις. Άνοιξε την εφαρμογή, ενεργοποίησε την τοποθεσία και περιηγήσου στις προσφορές της περιοχής σου. Όταν βρεις μια προσφορά που σου αρέσει, πάτησε για εξαργύρωση και δείξε τον κωδικό QR στο ταμείο.",
    faq2_q: "Είναι πραγματικά δωρεάν η εφαρμογή για τους καταναλωτές;",
    faq2_a:
      "Ναι! Το tiphop είναι 100% δωρεάν για τους καταναλωτές — χωρίς συνδρομές, κρυφές χρεώσεις ή προμήθειες συναλλαγών. Για τα καταστήματα, χωρίς συνδρομές και χωρίς πάγιες χρεώσεις — μόνο μια μικρή προμήθεια στις προσφορές που όντως εξαργυρώνονται.",
    faq3_q: "Πώς εξαργυρώνω μια προσφορά;",
    faq3_a:
      "Η εξαργύρωση είναι απλή! Μόλις βρεις μια προσφορά που θέλεις, πάτησε το κουμπί “Εξαργύρωση” στην εφαρμογή. Θα δημιουργηθεί ένας μοναδικός κωδικός QR. Δείξε τον στο κατάστημα στο ταμείο και θα τον σαρώσει για να εφαρμόσει άμεσα την έκπτωσή σου.",
    faq4_q: "Μπορώ να αποθηκεύσω προσφορές για αργότερα;",
    faq4_a:
      "Ναι! Σε μια προσφορά που ξεκινά αργότερα, πάτησε «Ειδοποίηση όταν ξεκινήσει» και θα σε ενημερώσουμε μόλις γίνει ενεργή. Αν πλησιάζει να λήξει και δεν την έχεις δεσμεύσει ακόμα, θα σου στείλουμε υπενθύμιση πριν κλείσει.",
    faq5_q: "Έχω κατάστημα. Πώς ξεκινάω;",
    faq5_a:
      "Το ξεκίνημα είναι εύκολο, χωρίς καμία προκαταβολική χρέωση. Δημιούργησε λογαριασμό καταστήματος μέσω της εφαρμογής ή του ιστότοπού μας και μπορείς να ξεκινήσεις να ανεβάζεις προσφορές αμέσως. Δεν υπάρχουν πακέτα, συνδρομές ή χρεώσεις ανάρτησης — μόνο μια μικρή προμήθεια στις προσφορές που όντως εξαργυρώνονται. Η ομάδα μας θα σε καθοδηγήσει σε όλη τη διαδικασία.",
    faq6_q: "Τι είδους επιχειρήσεις μπορούν να χρησιμοποιήσουν το tiphop;",
    faq6_a:
      "Οποιαδήποτε τοπική επιχείρηση με φυσικό σημείο μπορεί να χρησιμοποιήσει το tiphop! Περιλαμβάνονται εστιατόρια, καφετέριες, καταστήματα λιανικής, κομμωτήρια, γυμναστήρια, χώροι ψυχαγωγίας και πάροχοι υπηρεσιών. Αν έχεις αδιάθετη διαθεσιμότητα ή απόθεμα που θέλεις να πουλήσεις σε έκπτωση, το tiphop είναι ιδανικό για σένα.",

    // CTA + contact
    cta_title: "Έτοιμος να ξεκινήσεις να εξοικονομείς;",
    cta_sub:
      "Γίνε μέλος χιλιάδων χρηστών που ανακαλύπτουν καθημερινά σπουδαίες τοπικές προσφορές. Άνοιξε την εφαρμογή και πάρε την πρώτη σου προσφορά!",
    contact_title: "Επικοινώνησε μαζί μας",
    contact_sub: "Έχεις ερωτήσεις; Θα χαρούμε να σε ακούσουμε.",
    form_name: "Το όνομά σου",
    form_email: "Το email σου",
    form_message: "Το μήνυμά σου",
    form_send: "Αποστολή μηνύματος",
    form_sending: "Αποστολή…",
    form_thanks: "Ευχαριστούμε! Θα επικοινωνήσουμε σύντομα μαζί σου.",
    form_error: "Δεν στάλθηκε. Στείλε μας email στο tiphop.app@gmail.com.",

    // Footer
    footer_tagline: "Συνδέουμε τους καταναλωτές με τοπικά καταστήματα μέσα από χρονικά περιορισμένες εκπτώσεις.",
    footer_product: "Προϊόν",
    footer_company: "Εταιρεία",
    footer_legal: "Νομικά",
    footer_about: "Σχετικά με εμάς",
    footer_careers: "Καριέρα",
    footer_blog: "Blog",
    footer_privacy: "Πολιτική Απορρήτου",
    footer_terms: "Όροι Χρήσης",
    footer_cookies: "Πολιτική Cookies",
    footer_rights: "© {year} tiphop. Με επιφύλαξη παντός δικαιώματος.",
  },
};
